import TopOfMind from './TopOfMind';
import './TopOfMind.scss';

export default TopOfMind;
